import { t } from "@repo/translation";
import { FilterCheckbox } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { useOrderCreationMethods } from "./orderMethod";
import { type FilterItemsProps } from "./type";

export const OrderMethodFilter = ({ filters, actions }: FilterItemsProps) => {
  const orderCreationMethods = useOrderCreationMethods();

  return (
    <FilterListContainer id="order-method-filter">
      {orderCreationMethods?.map((label) => (
        <FilterCheckbox
          key={label}
          id={label}
          label={t(`order_method.${label}`)}
          checked={isChecked(filters.orderMethod, label)}
          onCheckFilter={actions.setOrderMethod}
          value={label}
        />
      ))}
    </FilterListContainer>
  );
};
